module.exports = __webpack_public_path__ + "09f4d8e4337db6fe6d4e5ca7caed7ce9.pdf";